// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountDocumentRelationshipModel {
    static getAttributeTypeMap() {
        return AccountDocumentRelationshipModel.attributeTypeMap;
    }
}
AccountDocumentRelationshipModel.discriminator = undefined;
AccountDocumentRelationshipModel.additionalProperties = false;
AccountDocumentRelationshipModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "comment",
        "baseName": "comment",
        "type": "string"
    },
    {
        "name": "isHidden",
        "baseName": "isHidden",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountDocumentRelationshipModel.js.map